/**
 * Favorite Button - Social action for favoriting content
 *
 * Filled circular button with heart outline icon for favorite/like functionality.
 * Can be used in headers, cards, photo galleries, or any context where
 * favoriting content is appropriate.
 */

import { Button } from '../../../ui/Button';
import { HeartOutlineIcon } from '../../../ui/icons';

/**
 * Props for social action buttons
 */
export type SocialActionButtonProps = {
  onClick: () => void;
  'aria-label': string;
  disabled?: boolean;
};

/**
 * Favorite Button Component
 *
 * @example
 * <FavoriteButton
 *   onClick={() => toggleFavorite(listing)}
 *   aria-label="Add to favorites"
 * />
 *
 * @note Currently shows outline heart - could be extended to support
 * filled/unfilled states based on favorite status
 */
export const FavoriteButton = ({ onClick, 'aria-label': ariaLabel, disabled = false }: SocialActionButtonProps) => (
  <Button
    shape="circle"
    tone="brand"
    emphasis="filled"
    size="md"
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
  >
    <HeartOutlineIcon />
  </Button>
);
